<template>
  <div class="weiterbildung" id="weiterbildung">
    <canvas id="the-canvas" style="display:none; direction: ltr;"></canvas>
    <transition name="simplefade">
    <div ref="pdfModal" v-if="ui.showModal" class="pdfModal">
      <div @click="closePdf()" class="close" style=""><div class="x">X</div></div>
      <transition name="simplefade" mode="out-in">
      <div v-if="!ui.pdfLoading" :key="1">
        <div class="flipHead grid-x pt-20">
          <div class="cell small-6 text-center"><span @click="$refs.pdf.flipLeft()" class="icon">&#8678;</span></div>
          <div class="cell small-6 text-center"><span @click="$refs.pdf.flipRight()" class="icon">&#8680;</span></div>
        </div>
        <flipbook ref="pdf" v-if="pdfLoaded" :key="currentPdf.length" class="flipbook mt-5" :singlePage="false" :zooms="[1,2]" :pages="currentPdf">
        </flipbook>
      </div>
      <div v-else class="flex-center" :key="2">
        <div class="l-container">
          <div class="loader">
          </div>
        </div>
      </div>
      </transition>
    </div>
    </transition>
    <div ref="backdrop" v-if="ui.showBackdrop" class="backdrop" @click="closePdf()">
    </div>
    <div class="grid-container fluid">
      <div class="grid-x">
        <div class="cell large-offset-2 small-12 large-8 relative p-3">
          <div class="grid-x">
            <div v-if="$store.compShowByDate && !state.app.isVertrieb" class="cell small-12 large-12 relative">
              <div class="card">
                <img src="@/assets/Webinare_Bild_Final.jpg" />
                <div class="card-content">
                  <h3>Die neue ERGO BU per Mausklick:<br>Interesse an einem Webinar?</h3>
                  <p>Gerne vereinbaren wir einen Termin mit Ihnen.</p>
                  <a href="mailto:ServiceTeamLeben@ergo.de" @click="$store.trackingClick('WebinarEmail');"><div class="btn big-red mt-10 link"><span>E-Mail senden</span></div></a>
                </div>
              </div>
            </div>
            <div v-if="$store.compShowByDate && !state.app.isVertrieb" class="cell small-12 large-12 relative">
              <div class="card">
                <img src="@/assets/Tarifrechner_Bild_neu_vonERGO_Teaser-SBUCalculator2020_small.jpg">
                <div class="card-content">
                  <h3>Die neue ERGO BU in unserem Tarifrechner</h3>
                  <p>Berechnen Sie selbst, wie günstig unsere neue ERGO BU für junge Leute sein kann. Und erleben Sie, wie das Ihre Beratung erleichtert.</p>
                  <a href="https://makler.ergo.de/calculators/sbu-calculator/quote" @click="$store.trackingClick('TariffCalculator');" target="_blank"><div class="btn big-red mt-10 link"><span>Zum Tarifrechner</span></div></a>
                </div>
              </div>
            </div>
            <!--div class="cell small-12 large-12 relative">
              <div class="card">
                  <img src="@/assets/Seminare_Bild_Final.jpg" />
                  <div class="card-content">
                    <h3>Die neue ERGO BU live und direkt: Unsere Seminare</h3>
                    <p>Die Produktschulung vor Ort – auch in Ihrer Nähe.</p>
                    <ul>
                      <li>Düsseldorf, 2. Juli 2020</li>
                      <li>Berlin, 3. August 2020</li>
                      <li>Hamburg, 14. August 2020</li>
                    </ul>
                    <div class="btn big-red link"><span>Jetzt anmelden</span></div>
                  </div>
              </div>
            </div-->
            <div class="cell small-12 large-12 relative no-margin">
              <p class="big-text">Die wichtigsten Infos rund um die neue ERGO BU: Jetzt. Hier. Live On Screen. </p>
              <div class="card center-img">
                  <img src="@/assets/weiterbildung3.png" />
              </div>
              <div class="centered">
                <div class="btn big-red link" @click="openPDF('Kurzpraesentation_ERGO_BU.pdf'); $store.trackingClick('ErgoBuPPT');"><span>Jetzt ansehen</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import Flipbook from 'flipbook-vue'

export default {
  name: 'Weiterbildung',
  components: {
    Flipbook
  },
  data() {
    return {
      state: this.$store.state,
      pdfLoaded: false,
      currentPdf: [],
      ui: {
        showBackdrop: false,
        showModal: false,
        pdfLoading: false
      }
    }
  },
  mounted() {

  },
  methods: {
    async openPDF(pdf) {
      this.pdfLoaded = false
      let t1 = new Date().getTime()
      this.ui.pdfLoading = true
      this.ui.showBackdrop = true
      this.ui.showModal = true
      let el = document.getElementById('app')
      //el.appendChild(this.$refs.pdfModal)
      //el.appendChild(this.$refs.backdrop)

      this.currentPdf = [null]
      //pdfjsLib.GlobalWorkerOptions.workerSrc = '//cdn.jsdelivr.net/npm/pdfjs-dist@2.3.200/build/pdf.worker.min.js';
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'static/js/pdf.worker.min.js';
      //var loadingTask = pdfjsLib.getDocument('static/pdf/'+pdf);
      pdf = await pdfjsLib.getDocument('static/pdf/'+pdf)
      let w = 0
      let h = 0
      let viewport
      console.log("pdf", pdf)
      for (let i = 1; i <= pdf._pdfInfo.numPages; i++) {
        //let canvas = document.createElement('canvas')
        let page
        try {
          page = await pdf.getPage(i)
        } catch(err) {
          console.log(err)
        }
        console.log("page", page)
        let scale = 1.5
        //if (i == 1) {
          viewport = await page.getViewport({scale: scale});
          w = viewport.width
          h = viewport.height
        //}

        // Prepare canvas using PDF page dimensions
        let canvas = document.getElementById('the-canvas');
        let context = canvas.getContext('2d');
        canvas.width = w;
        //canvas.height = canvas.width * 1.41;
        canvas.height = h;
        //canvas.height = canvas.width * 1.41;
        

        // Render PDF page into canvas context
        let renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        let url
        try {
          await page.render(renderContext).promise;
          url = await canvas.toDataURL()
        } catch(err) {
          console.log(err)
        }
        this.currentPdf.push(url)
      }
      this.pdfLoaded = true
      console.log("currentpdf", this.currentPdf)
      let t2 = new Date().getTime()
      let td = t2-t1
      let d = td - 1500
      if (d > 0) await this.$sleep(d)
      this.ui.pdfLoading = false
    },
    closePdf() {
      this.ui.showBackdrop = false
      this.ui.showModal = false
      this.pdfLoading = false
    },

  }
}
</script>

<style lang="stylus" scoped>
.flex-center {
  display:flex
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.l-container {
  opacity:0.9
	width: 200px;
	height: 200px;
	border-radius: 100%;
	background: linear-gradient(165deg, rgba(255,255,255,1) 0%, rgb(220, 220, 220) 40%, rgb(170, 170, 170) 98%, rgb(10, 10, 10) 100%);
	//position: relative;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.loader {
	text-align:left
}

.loader:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	border-radius: 100%;
	border-bottom: 0 solid #ffffff05;
	
	box-shadow: 
		0 -10px 20px 20px #ffffff40 inset,
		0 -5px 15px 10px #ffffff50 inset,
		0 -2px 5px #ffffff80 inset,
		0 -3px 2px #ffffffBB inset,
		0 2px 0px #ffffff,
		0 2px 3px #ffffff,
		0 5px 5px #ffffff90,
		0 10px 15px #ffffff60,
		0 10px 20px 20px #ffffff40;
	filter: blur(3px);
	animation: 2s rotate linear infinite;
}

@keyframes rotate {
	100% {
		transform: rotate(360deg)
	}
}
.pdfModal {
  z-index:200
  position: fixed
  //min-height:400px
  //min-width:400px
  width:100%
  height:100% //new
  top: 50%;
  transform: translateY(-50%);
  left:0;
  right:0;
  margin: 0 auto;
  text-align:center
  background:transparent
  padding-bottom:2.5vw
  .click-to-flip {
    //z-index:201
  }
  .flipHead {
    font-size:60px
    font-weight:bold
    //color: #00305D
    color: white
    .icon {
      cursor: pointer
      color:white
    }
  }
  .bounding-box {
    box-shadow: 0 0 20px 2px rgba(1,1,1,0.4)
  }
  .close {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* add code below to also center horizontally */
    align-items: center;
    font-size:30px;
    cursor:pointer
    z-index:202
    border:1px solid white
    color:white; width:80px
    height:80px
    text-align:center
    position:fixed
    top:10px
    right:10px
    border-radius:50%
    transition: all .3s ease
    &:hover {
      background-color:white
      color: black
    }
    .x {

    }
    @media screen and (max-width: 39.9375em) {
      width:50px
      height:50px
      font-size:20px
    }
  }
}
.backdrop {
  position: fixed
  width:100%
  height:100%
  top:0px
  left:0px
  z-index: 100
  background-color:rgba(1,1,1,0.5)
}
.flipbook {
  max-width:85vw
  width: auto;
  height:85vh;
  max-height: 85vh;

  left: 0;
  right: 0;
  margin: 0 auto;
}

.p-3 {
  padding 8.6em 2.8em
  @media screen and (max-width: 39.9375em) {
    padding 3.3em .6em
  }
}

.big-text {
  font-size 2em
  font-weight bold
  text-align center
}

.centered {
  display flex
  justify-content center
}

.btn {
  display inline-block 

  &.big-red {
    background-color #BE1528
    padding 1.1em 6.7em
    text-align center
    border-radius 2em
    box-shadow 0 .3em 1em .3em rgba(0,0,0,0.5)

    span {
      font-size 1.14em
      color #ffffff
      font-weight bold
    }
  }
}

.card {
  border-radius .4em
  box-shadow 0 0.4em 1em 0.2em rgba(0,0,0,0.3)
  margin-bottom 10em

  @media screen and (max-width: 39.9375em) {
    margin-bottom 3.3em
  }

  &.center-img {
    height 28.7em
    justify-content center
    align-items center
    margin 1em 0 2em

    @media screen and (max-width: 39.9375em) {
      height 16em
      padding 0 7.3em

      img {
        height auto
      }
    }
  }

  .card-content {
    padding 2.1em 2.4em
    h3 {
      color #8E0038
      line-height: 1.2
      font-size 2em
      font-weight bold
      font-family: 'FedraSerifAPro'
    }
    ul {
      list-style none
      // list-style-image url(/static/checkmark.png)

      li {
        font-weight bold
        background url('~@/assets/checkmark.png') no-repeat left top
        padding 0 0 1em 2em;
        margin 0
      }
    }
  }
}

.simplefade-enter-active {
  transition: all 0.5s ease;
}

.simplefade-leave-active {
  transition: all 0.5s ease;
}

.simplefade-enter {
  opacity: 0;
}

.simplefade-leave-to {
  opacity: 0;
}

</style>